var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysNews = function SvgSysNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.795 21.002a2.618 2.618 0 0 1-2.613-2.608V5.166a1.222 1.222 0 0 1 1.22-1.22h8.232a4.895 4.895 0 0 0-.35 1.042H4.397c-.094 0-.172 3.484-.172 3.584v9.816a1.571 1.571 0 0 0 1.57 1.567h10.511c-.343-.45-.528-1-.527-1.567v-7.615c.341.102.693.167 1.048.194v.978h2.958a1.222 1.222 0 0 1 1.22 1.217v5.226a2.611 2.611 0 0 1-2.612 2.614H5.795Zm11.033-2.617a1.564 1.564 0 1 0 3.13-.006v-5.227a.166.166 0 0 0-.167-.168h-2.963v5.4ZM6.38 16.198a.64.64 0 0 1 0-1.28h7.25a.639.639 0 1 1 0 1.28H6.38Zm0-3.412a.64.64 0 0 1 0-1.278h3.839a.641.641 0 0 1 .664.64.638.638 0 0 1-.664.638h-3.84Zm0-3.412a.638.638 0 0 1-.252-1.237.638.638 0 0 1 .252-.04h6.275c.22.467.51.898.86 1.277H6.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DB001A",
    d: "M17.182 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  })));
};
export default SvgSysNews;